import { Directive, Input, OnDestroy, ViewContainerRef, ComponentRef, effect } from "@angular/core";
import { Note } from "@orion2/models/tocitem.models";
import { NoteService, Store } from "@viewer/core";
import { NoteComponent } from "@viewer/toc-items/note-module/note/note.component";

@Directive({
  selector: "[oNoteAnchor]",
  standalone: false
})
export class NoteAnchorDirective implements OnDestroy {
  @Input() item: Note;

  private compRef: ComponentRef<NoteComponent>;

  constructor(
    private store: Store,
    private vcr: ViewContainerRef,
    private noteService: NoteService
  ) {
    effect(() => {
      if (this.store.displayDoneSignal()) {
        this.attach();
      }
    });
  }

  ngOnDestroy() {
    this.detach();
  }

  /**
   * Create a copy of the noteComponent based on data from this.item
   * Place the copy on corresponding anchor (before the radio button)
   * @memberof NoteAnchorDirective
   */
  private attach() {
    const input = document.querySelector(`.note-radio-button[value='${this.item.anchor?.id}']`);

    if (!input?.parentElement) {
      this.item.anchor.notFound = true;
      this.noteService.updateTocItemForTargetToNext();
      return;
    }

    this.compRef = this.vcr.createComponent(NoteComponent);
    this.compRef.instance.item = this.item;
    this.compRef.location.nativeElement.classList.add("from-fulltext");
    input.parentElement.insertBefore(this.compRef.location.nativeElement, input);
  }

  /**
   * Destroy the component placed in content by attach()
   * @memberof NoteAnchorDirective
   */
  private detach() {
    this.compRef?.destroy();
    this.compRef = null;
  }
}
